import CustomInput from "@/components/CustomInput/CustomInput.vue";

export default {
    name: 'ResetPassword',
    components: {CustomInput},
    data() {
        return {
            validToken: false,
            getTokenRequestSend: false,
            new_password: '',
            confirm_new_password: '',
            errorConfirm: false,
            isBlockedBtn: true,
        }
    },
    computed: {
        isPasswordsMatched () {
            return this.new_password === this.confirm_new_password
        },
        isError () {
            return !this.isPasswordsMatched && this.new_password.length && this.confirm_new_password.length
        }
    },
    created() {
        this.check()
    },
    mounted() {},
    methods: {
        toReset() {
            if (this.checkPasswords()) {
                this.$store.dispatch('resetPassword', {
                    token: this.$route.params.token,
                    password: this.new_password
                }).then(res => {
                    this.$router.push({
                        name: 'Secure',
                        params: {
                            messagePassword: true
                        }
                    })
                })
            } else {
                this.errorConfirm = true
            }
        },
        newPassword(data) {
            this.new_password = data.inp
            this.blockedButtonListener()
        },
        confirmNewPassword(data) {
            this.confirm_new_password = data.inp
            this.blockedButtonListener()
        },
        check() {
            this.$store.dispatch('checkToken', this.$route.params.token)
                .then((resp) => {
                    this.validToken = resp.status
                    this.getTokenRequestSend = true
                })
        },
        checkPasswords() {
            return (this.new_password.trim().length && this.confirm_new_password.trim().length) &&
                (this.new_password === this.confirm_new_password);
        },
        blockedButtonListener() {
            this.isBlockedBtn = !this.checkPasswords()
        }
    }
}
